import { UserStatus } from "../../constants/constants";
import http from "../../rest/http";

export const StaffListService = async (
  pageNumber: any,
  rowsPerPage: any,
  key: any
) => {
  try {
    let URL = `/api/v1/user/list-all?status=${
      key === null || key === undefined ? "" : key
    }&page=${pageNumber}&size=${rowsPerPage}`;

    if (key === UserStatus.CONFLICT) {
      URL = `/api/v1/user/list-all?page=${pageNumber}&size=${rowsPerPage}&conflict=${true}`;
    }
    const response = await http.get(URL);
    return response;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

export const StaffExitReasonListService = async () => {
  try {
    let URL = `/api/v1/user/list-exit-reasons`;
    const response = await http.get(URL);
    console.log("response", response);
    return response;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

export const exitStaff = async (userId: string, data: any) => {
  try {
    let URL = `/api/v1/user/${userId}`;
    const response = await http.post(URL, data);
    return response;
  } catch (error) {
    console.error("Error in exit staff API", error);
    throw error;
  }
};
